import { call, cancelled, delay, put, takeLatest } from 'redux-saga/effects';

import axios from 'axios';

import { ObjectInterface } from '@interfaces';

import magentoService from '@services/magento.service';

import { actions } from '@store/actions/report/latest-order';
import { actions as reportShareActions } from '@store/actions/report/share';
import { actions as shareActions } from '@store/actions/share';
import { Action, ActionType } from '@store/interfaces/report/latest-order';

interface AnyResponseInterface {
  [key: string]: any;
}
// const takeLatest2 = (patternOrChannel: string, saga: any, ...args: any[]) =>
//   fork(function* (): any {
//     let lastTask: Task<any> | null = null;
//     while (true) {
//       const action = yield take(patternOrChannel);
//       if (lastTask) {
//         yield cancel(lastTask); // cancel is no-op if the task has already terminated
//       }
//       // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
//       lastTask = yield fork(saga, ...args.concat(action));
//     }
//   });

function* requestShareDataLateGrid(): any {
  yield delay(100);
  yield put(reportShareActions.getLateItemState({}, false));
  yield put(shareActions.dispatcher.getDispatchers(false));
}

function* request({ payload }: Action): any {
  const cancelTokenSource = axios.CancelToken.source();
  try {
    const params: ObjectInterface = { ...(payload || {}) };
    const options: ObjectInterface = { cancelToken: cancelTokenSource.token };
    const dataResponse: AnyResponseInterface = yield call(magentoService.getLatestOrder.bind(magentoService), params, options);
    yield put(actions.getItemsSuccess(dataResponse));
  } catch (error: any) {
    yield put(actions.getItemsFailure(error?.message));
  } finally {
    if (yield cancelled()) {
      console.log('cancel');
      cancelTokenSource.cancel();
    }
  }
}

function* requestSaga() {
  yield takeLatest(ActionType.GET_ITEMS_REQUEST, request);
  yield takeLatest(ActionType.GET_SHARE_DATE_LATE_GRID, requestShareDataLateGrid);
}
export default requestSaga;
